module.exports = __webpack_public_path__ + "static/ARB_ILLUSTRATION_1-e9e557f3a7c134abe54324078e62de01.jpg";